import { cn } from "../../lib/format";
import type { ReactNode } from "react";

export default function KpiCard({
  label,
  value,
  delta,
  icon,
  tone = "paper",
}: {
  label: string;
  value: ReactNode;
  delta?: string;
  icon?: ReactNode;
  tone?: "paper" | "ink";
}) {
  const isInk = tone === "ink";
  return (
    <div
      className={cn(
        "rounded-md p-5 border",
        isInk
          ? "bg-ink-card text-paper border-white/5"
          : "bg-paper-soft/60 border-[rgba(42,36,26,0.12)]",
      )}
    >
      <div className="flex items-center justify-between mb-3">
        <div className={cn("eyebrow", isInk && "text-paper/40")}>{label}</div>
        {icon && <span className={cn(isInk ? "text-paper/50" : "text-ink-faint")}>{icon}</span>}
      </div>
      <div className="font-serif text-4xl">{value}</div>
      {delta && (
        <div className={cn("mt-1 text-xs", isInk ? "text-paper/50" : "text-ink-faint")}>
          {delta}
        </div>
      )}
    </div>
  );
}
